import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id DAAF6988-6EE9-4595-A758-294C83C7304B
 * name navigation
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/navigation.svg
 * tags
 * - Navigation 
 */
export const NavigationIcon = createSvgIcon(<><path d="M12,2L4.5,20.29L5.21,21L12,18L18.79,21L19.5,20.29L12,2Z" /></>, 'NavigationIcon');
export default NavigationIcon